export function sortOrder(arr: any[]) {
  return arr.sort((a, b) => a.orderNumber - b.orderNumber);
}
